import MayRest from "may-ui-core/rest/"

var mayRest = new MayRest({
    service: "K1Interview"
});

export default {
    loginForCandidate: function (userid, password) {
        var promise = mayRest.post('LoginForCandidate', { UserID: userid, Password: password })
        return promise;
    },
    loginForResult: function (userid, password) {
        var promise = mayRest.post('LoginForResult', { UserID: userid, Password: password })
        return promise;
    },
}